export default __webpack_public_path__ + "static/media/macTech2.e8c27c66.png";